var HistoryLogModule = (function () {
    function HistoryLogModule() {
    }
    return HistoryLogModule;
}());
export { HistoryLogModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/history-log/history-log.module.ts.pre-build-optimizer.js